import { Vue, Component } from 'vue-property-decorator';
import { Capacitor } from '@capacitor/core';
import { Printer } from '@awesome-cordova-plugins/printer';

declare const window: any;

@Component
export default class PrintMixin extends Vue {
  public printing: boolean = false;

  async handlePrinting(url: string) {
    this.printing = true;

    try {
      if (window.electronVersions && 'electron' in window.electronVersions) {
        this.handlePrintingElectron(url);
      } else if (Capacitor.isNativePlatform()) {
        this.handlePrintingCapacitor(url);
      } else {
        this.handlePrintingWeb(url);
      }
    } finally {
      setTimeout(() => {
        this.printing = false;
      }, 1000);
    }
  }

  private async handlePrintingWeb(url: string): Promise<void> {
    const blobUrl = await this.getUrlFile(url);
    printJS({printable: blobUrl});
  }

  private handlePrintingElectron(url: string) {
    window.electronAPI.printContents(url);
  }

  private async handlePrintingCapacitor(url: string): Promise<void> {
    const blobUrl = await this.getUrlFile(url);
    const response = await fetch(blobUrl);
    const blob = await response.blob();

    // Step 3: Convert Blob to Base64
    const base64DataUrl = await this.blobToBase64DataUrl(blob);

    // Step 4: Check printer availability
    const isAvailable = await Printer.isAvailable();
    if (!isAvailable) {
      alert('No printer available');
      return;
    }

    // Step 5: Print the PDF using base64
    await Printer.print(`base64://${base64DataUrl.split(',')[1]}`);
  }


  private async getUrlFile(url: string) {
    const hash = this.getHash(url);
    let cachedUrl = await this.$FilesCache.getUrlFile(hash);
    if(!cachedUrl) {
      cachedUrl = await this.downloadFileAndGetAsBlobUrl(url);
    }
    return cachedUrl;
  }

  private getHash(url: string): string {
    const resource = url.substring(url.lastIndexOf('/') + 1);
    return resource.split('#')[0];
  }

  private async downloadFileAndGetAsBlobUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.arrayBuffer();
        })
        .then(async (arrayBuffer: ArrayBuffer) => {

          const uint8Array = new Uint8Array(arrayBuffer);
          const blob = new Blob([uint8Array], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          await this.$FilesCache.cacheFile(this.getHash(url), uint8Array);
          
          resolve(blobUrl);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  private blobToBase64DataUrl(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

}
